var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2873_1811)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2873_1811",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.990234C5.79086 0.990234 4 2.78109 4 4.99023V24.4282C4 26.6373 5.79086 28.4282 8 28.4282H15.0471L18.5833 31.8579L22.1196 28.4282H28C30.2091 28.4282 32 26.6373 32 24.4282V4.99023C32 2.7811 30.2091 0.990234 28 0.990234H8Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.990234C5.79086 0.990234 4 2.78109 4 4.99023V24.4282C4 26.6373 5.79086 28.4282 8 28.4282H15.0471L18.5833 31.8579L22.1196 28.4282H28C30.2091 28.4282 32 26.6373 32 24.4282V4.99023C32 2.7811 30.2091 0.990234 28 0.990234H8Z",
    fill: "#E5BD55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 28.4282L16.4395 26.9925L15.8576 26.4282H15.0471V28.4282ZM18.5833 31.8579L17.1909 33.2936L18.5833 34.6441L19.9758 33.2936L18.5833 31.8579ZM22.1196 28.4282V26.4282H21.309L20.7272 26.9925L22.1196 28.4282ZM6 4.99023C6 3.88566 6.89543 2.99023 8 2.99023V-1.00977C4.68629 -1.00977 2 1.67652 2 4.99023H6ZM6 24.4282V4.99023H2V24.4282H6ZM8 26.4282C6.89543 26.4282 6 25.5327 6 24.4282H2C2 27.7419 4.68629 30.4282 8 30.4282V26.4282ZM15.0471 26.4282H8V30.4282H15.0471V26.4282ZM13.6546 29.8638L17.1909 33.2936L19.9758 30.4222L16.4395 26.9925L13.6546 29.8638ZM19.9758 33.2936L23.512 29.8638L20.7272 26.9925L17.1909 30.4222L19.9758 33.2936ZM28 26.4282H22.1196V30.4282H28V26.4282ZM30 24.4282C30 25.5327 29.1046 26.4282 28 26.4282V30.4282C31.3137 30.4282 34 27.7419 34 24.4282H30ZM30 4.99023V24.4282H34V4.99023H30ZM28 2.99023C29.1046 2.99023 30 3.88566 30 4.99023H34C34 1.67653 31.3137 -1.00977 28 -1.00977V2.99023ZM8 2.99023H28V-1.00977H8V2.99023Z",
    fill: "white",
    mask: "url(#path-1-inside-1_2873_1811)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2873_1811",
    x: 0,
    y: 0.990234,
    width: 36,
    height: 38.8672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2873_1811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2873_1811",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerYellow);
export default __webpack_public_path__ + "static/media/map-marker-yellow.168ddce13c282aa1bb9e3961422e02a0.svg";
export { ForwardRef as ReactComponent };